import type { LayerRaw } from '@tsyl/karonte/lib/types/layers'

import { LAYER_ATTRIBUTIONS } from '@/constants/layers/attributions'
import type { LayerInfo } from '@/types/LayerInfo'

const info: LayerInfo = {
  description: {
    'en-US': 'Generated from Shuttle Radar Topography Mission (SRTM) Digital Elevation Data Version 4',
    'es-ES': 'Generado a partir de Shuttle Radar Topography Mission (SRTM) Digital Elevation Data Version 4',
    'pt-BR': 'Gerado a partir de Shuttle Radar Topography Mission (SRTM) Digital Elevation Data Version 4',
    'fr-FR': 'Généré à partir de Shuttle Radar Topography Mission (SRTM) Digital Elevation Data Version 4'
  },
  credit: LAYER_ATTRIBUTIONS.nasa,
  sourceUrl: 'https://developers.google.com/earth-engine/datasets/catalog/CGIAR_SRTM90_V4'
}

const slopeNorthAfrica: LayerRaw = {
  id: 'Slope',
  type: 'WMS',
  url: '/wfas-proxy/geoserver/wms',
  extraArcgisParameter: { copyright: info.credit },
  title: {
    'en-US': 'Slope',
    'pt-BR': 'Inclinação',
    'es-ES': 'Pendiente',
    'fr-FR': 'Pente'
  },
  zindex: 1,
  active: true,
  activeTarget: 'visibility',
  enabled: false,
  opacity: 0.5,
  customProperties: { group: 'reference', info },
  legend: {
    title: 'n/a'
  },
  sublayers: [
    {
      id: 'naf:NWAF_SLOPE',
      visible: true,
      legend: {
        title: {
          'en-US': 'Slope',
          'pt-BR': 'Inclinação',
          'es-ES': 'Pendiente',
          'fr-FR': 'Pente'
        },
        items: [
          {
            icon: 'mdi-circle',
            color: '#1A9641',
            text: {
              'en-US': 'Less than 5%',
              'pt-BR': 'Menos de 5%',
              'es-ES': 'Menos de 5%',
              'fr-FR': 'Moins de 5%'
            }
          },
          {
            icon: 'mdi-circle',
            color: '#A6D96A',
            text: {
              'en-US': '5% to 10%',
              'pt-BR': '5% a 10%',
              'es-ES': '5% a 10%',
              'fr-FR': '5% à 10%'
            }
          },
          {
            icon: 'mdi-circle',
            color: '#FFFFBF',
            text: {
              'en-US': '10% to 20%',
              'pt-BR': '10% a 20%',
              'es-ES': '10% a 20%',
              'fr-FR': '10% à 20%'
            }
          },
          {
            icon: 'mdi-circle',
            color: '#FDAE61',
            text: {
              'en-US': '20% to 30%',
              'pt-BR': '20% a 30%',
              'es-ES': '20% a 30%',
              'fr-FR': '20% à 30%'
            }
          },
          {
            icon: 'mdi-circle',
            color: '#D7191C',
            text: {
              'en-US': '30% to 45%',
              'pt-BR': '30% a 45%',
              'es-ES': '30% a 45%',
              'fr-FR': '30% à 45%'
            }
          },
          {
            icon: 'mdi-circle',
            color: '#A50026',
            text: {
              'en-US': '45%+',
              'pt-BR': '45%+',
              'es-ES': '45%+',
              'fr-FR': '45%+'
            }
          }
        ]
      }
    }
  ],
  icon: 'mdi-barley'
}

export default slopeNorthAfrica
